
import React from "react";
import CompanyLayout from "@/components/CompanyLayout";
import { Button } from "@/components/ui/button";
import { 
  ArrowRight, Mail, MapPin, Clock,
  Linkedin, Twitter
} from "lucide-react";

const Contact = () => {
  const pageTitle = "Contact Us";
  const pageDescription = "Get in touch with the Assembly team for support, sales inquiries, or general questions.";

  return (
    <CompanyLayout title={pageTitle} description={pageDescription}>
      {/* Hero Section */}
      <section className="bg-hero-gradient py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Get In Touch</h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-8">
              We'd love to hear from you. Contact us for support, sales inquiries, or just to say hello.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <Mail className="h-6 w-6 text-assembly-blue" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">Email</h3>
                      <p className="text-gray-700"><a href="mailto:support@joinassembly.com" className="hover:text-assembly-blue">support@joinassembly.com</a></p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <MapPin className="h-6 w-6 text-assembly-orange" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">Address</h3>
                      <p className="text-gray-700">
                        13810 FNB Pkwy, Suite 401<br />
                        Omaha, NE 68154<br />
                        USA
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <Clock className="h-6 w-6 text-assembly-purple" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">Support Hours</h3>
                      <p className="text-gray-700">
                        Monday - Friday<br />
                        8:00 AM - 8:00 PM ET
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Connect With Us</h2>
                <div className="flex space-x-4">
                  <a href="https://www.linkedin.com/company/joinassembly/" target="_blank" rel="noopener noreferrer" className="bg-blue-100 hover:bg-blue-200 p-3 rounded-full transition-colors">
                    <Linkedin className="h-6 w-6 text-blue-600" />
                  </a>
                  <a href="https://twitter.com/join_assembly" target="_blank" rel="noopener noreferrer" className="bg-blue-100 hover:bg-blue-200 p-3 rounded-full transition-colors">
                    <Twitter className="h-6 w-6 text-blue-400" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="rounded-2xl overflow-hidden shadow-lg h-[400px]">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d-96.0205!3d41.2524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s13810%20FNB%20Pkwy%2C%20Omaha%2C%20NE%2068154!5e0!3m2!1sen!2sus" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Assembly Office Location"
            />
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 bg-orange-gradient rounded-3xl mx-6 my-12">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Ready to transform your workplace?</h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Join thousands of companies using Assembly to build a culture of recognition and engagement.
          </p>
          <Button 
            className="bg-white hover:bg-gray-50 text-gray-900 py-6 px-10 rounded-xl text-lg font-medium transition-all hover:shadow-lg flex items-center gap-2 mx-auto"
            onClick={() => {
              if (typeof window !== 'undefined') {
                window.location.href = 'https://joinassembly.com/book-demo';
              }
            }}
          >
            Book a Demo
            <ArrowRight className="h-5 w-5" />
          </Button>
        </div>
      </section>
    </CompanyLayout>
  );
};

export default Contact;
